var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("CorporateNavigation", { attrs: { ActivePage: "dashboard" } }),
      _vm._v(" "),
      _vm.rm
        ? _c(
            "div",
            {
              staticClass: "container",
              staticStyle: { "margin-top": "80px", "padding-top": "40px" },
            },
            [
              _c("div", { staticClass: "row" }, [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-6 text-right align-self-end" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-success",
                        staticStyle: { padding: "0.7em 2em" },
                        attrs: { role: "button" },
                        on: { click: _vm.handleUpdateStrategySettingsCommand },
                      },
                      [_vm._v("Save")]
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("hr", {
                staticStyle: { "border-color": "#bbb", margin: "20px 0 60px" },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("Currency:")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.rm.Currency,
                        expression: "rm.Currency",
                      },
                    ],
                    staticClass: "form-control",
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.rm,
                          "Currency",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      },
                    },
                  },
                  _vm._l(_vm.currencies, function (c) {
                    return _c("option", { domProps: { value: c } }, [
                      _vm._v(_vm._s(c)),
                    ])
                  }),
                  0
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("Financial Year Start Month:")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.rm.FiscalYearStartMonth,
                        expression: "rm.FiscalYearStartMonth",
                      },
                    ],
                    staticClass: "form-control",
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.rm,
                          "FiscalYearStartMonth",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      },
                    },
                  },
                  [
                    _c("option", { domProps: { value: 1 } }, [
                      _vm._v("January"),
                    ]),
                    _vm._v(" "),
                    _c("option", { domProps: { value: 2 } }, [
                      _vm._v("February"),
                    ]),
                    _vm._v(" "),
                    _c("option", { domProps: { value: 3 } }, [_vm._v("March")]),
                    _vm._v(" "),
                    _c("option", { domProps: { value: 4 } }, [_vm._v("April")]),
                    _vm._v(" "),
                    _c("option", { domProps: { value: 5 } }, [_vm._v("May")]),
                    _vm._v(" "),
                    _c("option", { domProps: { value: 6 } }, [_vm._v("June")]),
                    _vm._v(" "),
                    _c("option", { domProps: { value: 7 } }, [_vm._v("July")]),
                    _vm._v(" "),
                    _c("option", { domProps: { value: 8 } }, [
                      _vm._v("August"),
                    ]),
                    _vm._v(" "),
                    _c("option", { domProps: { value: 9 } }, [
                      _vm._v("September"),
                    ]),
                    _vm._v(" "),
                    _c("option", { domProps: { value: 10 } }, [
                      _vm._v("October"),
                    ]),
                    _vm._v(" "),
                    _c("option", { domProps: { value: 11 } }, [
                      _vm._v("November"),
                    ]),
                    _vm._v(" "),
                    _c("option", { domProps: { value: 12 } }, [
                      _vm._v("December"),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("Default P&L:")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.rm.DefaultPnlId,
                        expression: "rm.DefaultPnlId",
                      },
                    ],
                    staticClass: "form-control",
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.rm,
                          "DefaultPnlId",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      },
                    },
                  },
                  _vm._l(_vm.rm.Pnls, function (t) {
                    return _c("option", { domProps: { value: t.Id } }, [
                      _vm._v(_vm._s(t.Name)),
                    ])
                  }),
                  0
                ),
              ]),
              _vm._v(" "),
              _c("hr", { staticClass: "my-4" }),
              _vm._v(" "),
              _c("fieldset", [
                _c("legend", [_vm._v("Project total cost")]),
                _vm._v(" "),
                _c("div", { staticClass: "form-check" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.rm.IncludeCogs,
                        expression: "rm.IncludeCogs",
                      },
                    ],
                    staticClass: "form-check-input",
                    attrs: { type: "checkbox", id: "includeCogs" },
                    domProps: {
                      checked: Array.isArray(_vm.rm.IncludeCogs)
                        ? _vm._i(_vm.rm.IncludeCogs, null) > -1
                        : _vm.rm.IncludeCogs,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.rm.IncludeCogs,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(_vm.rm, "IncludeCogs", $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.rm,
                                "IncludeCogs",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.rm, "IncludeCogs", $$c)
                        }
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label",
                      attrs: { for: "includeCogs" },
                    },
                    [
                      _vm._v(
                        "\n                    Include COGS\n                "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-check" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.rm.IncludeOpex,
                        expression: "rm.IncludeOpex",
                      },
                    ],
                    staticClass: "form-check-input",
                    attrs: { type: "checkbox", id: "includeOpex" },
                    domProps: {
                      checked: Array.isArray(_vm.rm.IncludeOpex)
                        ? _vm._i(_vm.rm.IncludeOpex, null) > -1
                        : _vm.rm.IncludeOpex,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.rm.IncludeOpex,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(_vm.rm, "IncludeOpex", $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.rm,
                                "IncludeOpex",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.rm, "IncludeOpex", $$c)
                        }
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label",
                      attrs: { for: "includeOpex" },
                    },
                    [
                      _vm._v(
                        "\n                    Include OPEX\n                "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-check" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.rm.IncludeOther,
                        expression: "rm.IncludeOther",
                      },
                    ],
                    staticClass: "form-check-input",
                    attrs: { type: "checkbox", id: "includeOther" },
                    domProps: {
                      checked: Array.isArray(_vm.rm.IncludeOther)
                        ? _vm._i(_vm.rm.IncludeOther, null) > -1
                        : _vm.rm.IncludeOther,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.rm.IncludeOther,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.rm,
                                "IncludeOther",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.rm,
                                "IncludeOther",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.rm, "IncludeOther", $$c)
                        }
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label",
                      attrs: { for: "includeOther" },
                    },
                    [
                      _vm._v(
                        "\n                    Include Other Expenses\n                "
                      ),
                    ]
                  ),
                ]),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-lg-6" }, [
      _c(
        "h1",
        {
          staticStyle: {
            "font-size": "2em",
            "font-weight": "300",
            color: "#33475b",
            margin: "0",
          },
        },
        [_vm._v("Settings")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }